import { useQuery } from '@tanstack/react-query'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/**
 * Fetches vitals history for a patient, most recent first. The backend orders
 * by `desc(createdAt)` (see routes/os/vitals.ts), so callers can rely on index 0
 * being the newest entry (e.g. `formatLatestWeight`).
 */
export function useListPatientVitals(patientId: string) {
  const api = useOsApi()

  return useQuery({
    queryKey: ['patient-vitals', patientId],
    queryFn: async () => {
      const response = await api.get('/vitals', { query: { patientId } })
      if (!response.success) throw new Error(response.error.message)
      return response.data.vitals
    },
  })
}
